// extracted by mini-css-extract-plugin
export default {"wrapper":"fmh-highlight-label_wrapper__Mvi2q","text":"fmh-highlight-label_text__Vwl9Z","medium":"fmh-highlight-label_medium__XIVbc","small":"fmh-highlight-label_small__voTD-"};